import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'
import {
    createPriorityListUser,
    getArtist,
    getIPv4,
    getIsFormComplete,
    getRefCode,
    retrievePriorityListArtist,
    retrieveUserIPv4,
    setFriendRefCode,
    updatePriorityListUser,
} from 'redux/slices/priorityList'
import { getCreationError, getGetPriorityListUser } from 'redux/slices/priorityList'

import CountdownEndForm from 'components/priority-list/CountdownEndForm/CountdownEndForm'
import FriendReferral from 'components/priority-list/FriendReferral/FriendReferral'
import Header from 'components/priority-list/Header/Header'
import HeaderSuccess from 'components/priority-list/HeaderSuccess/HeaderSuccess'
import PriorityListForm from 'components/priority-list/PriorityListForm/PriorityListForm'
import PriorityListMetaForm from 'components/priority-list/PriorityListMetaForm/PriorityListMetaForm'
import _ from 'lodash'
import { connect } from 'react-redux'
import qs from 'query-string'
import { withStyles } from '@material-ui/core'
import { styles } from './styles'

class PriorityList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isCountdownComplete: false,
        }
    }

    componentDidMount() {
        this.props.retrievePriorityListArtist(_.get(this.props, 'match.params.artistId'))
        this.props.retrieveUserIPv4()

        //Get referral code from query string
        let search = _.get(this.props, 'location.search')
        if (_.isString(search)) {
            let code = qs.parse(search).ref_code
            this.props.setFriendRefCode(code)
        }
    }

    countdownCompleteCallback = () => {
        this.setState({ isCountdownComplete: true })
    }

    renderContent = () => {
        if (this.state.isCountdownComplete) {
            return (
                <CountdownEndForm
                    artist={this.props.artist}
                    createPriorityListUser={this.props.createPriorityListUser}
                    priorityListUser={this.props.priorityListUser}
                    ipv4={this.props.ipv4}
                    creationError={this.props.creationError}
                />
            )
        } else if (!_.isEmpty(this.props.priorityListUser) && this.props.isFormComplete) {
            return (
                <FriendReferral
                    priorityListUser={this.props.priorityListUser}
                    artistName={this.props.artist.name}
                    artistId={this.props.artist._id}
                />
            )
        } else if (!_.isEmpty(this.props.priorityListUser)) {
            return (
                <PriorityListMetaForm
                    artist={this.props.artist}
                    priorityListUser={this.props.priorityListUser}
                    updatePriorityListUser={this.props.updatePriorityListUser}
                    ipv4={this.props.ipv4}
                />
            )
        } else {
            return (
                <PriorityListForm
                    artist={this.props.artist}
                    createPriorityListUser={this.props.createPriorityListUser}
                    ipv4={this.props.ipv4}
                    refCode={this.props.refCode}
                    creationError={this.props.creationError}
                />
            )
        }
    }

    renderHeader = () => {
        const { classes } = this.props
        if (this.props.isFormComplete) {
            return (
                <div className={classes.headerContainerBlack}>
                    <HeaderSuccess artist={this.props.artist} />
                </div>
            )
        } else {
            return (
                <div
                    className={
                        this.state.isCountdownComplete ? classes.headerContainerDisabled : classes.headerContainerLive
                    }
                >
                    <Header
                        artist={this.props.artist}
                        disabledTheme={this.state.isCountdownComplete}
                        isFormComplete={this.props.isFormComplete}
                        countdownCompleteCallback={this.countdownCompleteCallback}
                    />
                </div>
            )
        }
    }

    render() {
        const { classes } = this.props
        return (
            <div className={classes.container}>
                {this.renderHeader()}
                <div className={classes.formContainer}>{!!this.props.ipv4.length && this.renderContent()}</div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    artist: getArtist(state),
    priorityListUser: getGetPriorityListUser(state),
    creationError: getCreationError(state),
    ipv4: getIPv4(state),
    isFormComplete: getIsFormComplete(state),
    refCode: getRefCode(state),
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            retrievePriorityListArtist,
            createPriorityListUser,
            updatePriorityListUser,
            retrieveUserIPv4,
            setFriendRefCode,
        },
        dispatch,
    )

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(PriorityList)
